import type { Scenario, Scene } from '../../types';

export const AI_BLOCK_PREVIEW_SCENE_ID = '__ai_block_preview__';

/** Scénario minimal pour prévisualiser un bloc IA avant insertion. */
export function buildAiBlockPreviewScenario(
  base: Scenario,
  block: Omit<Scene, 'id'>
): Scenario {
  const scene = { ...block, id: AI_BLOCK_PREVIEW_SCENE_ID } as Scene;
  return {
    ...base,
    metadata: {
      ...base.metadata,
      title: `${base.metadata.title} — aperçu bloc`,
      startScene: AI_BLOCK_PREVIEW_SCENE_ID,
    },
    scenes: [scene],
  };
}
